<div class="auditoria-header">
  <div class="auditoria-header__accent"></div>
  <div class="container auditoria-header__inner">
    <span class="material-icons auditoria-header__icon">history</span>
    <div>
      <h1 class="auditoria-header__title">Auditoría · <span>{{ tituloComponente }}</span></h1>
      <p class="auditoria-header__subtitle">Acciones registradas del componente</p>
    </div>
  </div>
</div>

<app-spinner
    [show]="!flagLoaded"
    [type]="'fullscreen'"
    [size]="'large'"
    [color]="'#B1476A'"
    [trackColor]="'#4CA7C8'"
    [text]="'Cargando auditoría...'"
    [showText]="true"
    [blurBackground]="true">
</app-spinner>

<div *ngIf="!flagLoaded" style="height: 100vh;"></div>

<div *ngIf="flagLoaded" class="auditoria-area auditoria-animate-in">
  <div class="container">
    <div class="barra-superior">
      <button mat-stroked-button class="btn-volver" (click)="volver()">
        <mat-icon>arrow_back</mat-icon> Volver
      </button>

      <button mat-stroked-button class="btn-exportar" (click)="exportarListado()">
        <mat-icon>download</mat-icon> Exportar
      </button>
    </div>

    <mat-form-field class="buscador" appearance="outline">
      <mat-label>Buscar en auditoría</mat-label>
      <span class="material-icons" matPrefix>search</span>
      <input
        matInput
        [ngModel]="termino"
        (ngModelChange)="aplicarFiltro($event)"
        placeholder="Usuario, acción, plan..."
        autocomplete="off"
      />
    </mat-form-field>

    <div class="mat-elevation-z8 tabla-wrapper">
      <table mat-table [dataSource]="dataSource" matSort>

        <ng-container matColumnDef="fecha">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Fecha </th>
          <td mat-cell *matCellDef="let e"> {{ e.fecha | date: 'dd/MM/yyyy HH:mm' }} </td>
        </ng-container>

        <ng-container matColumnDef="usuario">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Usuario </th>
          <td mat-cell *matCellDef="let e">
            <div class="usuario">
              <strong>{{ e.usuario?.nombreCompleto || '-' }}</strong>
              <small>{{ e.usuario?.email }}</small>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="accion">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Acción </th>
          <td mat-cell *matCellDef="let e">
            <span class="accion">
              <span class="material-icons">{{ iconoAccion(e.accion) }}</span>
              {{ labelAccion(e.accion) }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="resumen">
          <th mat-header-cell *matHeaderCellDef> Detalle </th>
          <td mat-cell *matCellDef="let e"> {{ resumenPayload(e) || '-' }} </td>
        </ng-container>

        <ng-container matColumnDef="resultado">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Resultado </th>
          <td mat-cell *matCellDef="let e">
            <span class="chip" [ngClass]="e.resultado === 'ERROR' ? 'chip--error' : 'chip--ok'">
              {{ e.resultado || 'EXITO' }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="acciones">
          <th mat-header-cell *matHeaderCellDef> Acciones </th>
          <td mat-cell *matCellDef="let e">
            <button mat-icon-button color="primary" title="Ver más" (click)="verDetalle(e)">
              <mat-icon>visibility</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" [attr.colspan]="displayedColumns.length">
            No hay registros que coincidan con "{{ termino }}".
          </td>
        </tr>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>

      <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]" aria-label="Seleccionar página"></mat-paginator>
    </div>
  </div>
</div>
